import { Transform } from 'class-transformer';
import { IsNotEmpty, IsOptional, MaxLength } from 'class-validator';
import { sanitizeString } from '../utils';
import { OrderLineUpdateDto } from './order-line-update.dto';

export class OrderUpdateDto {
  /**
   * Id of the order on the customer's system
   * @example 'jelmoli-system-id-0001'
   */
  @MaxLength(20)
  @IsOptional()
  @Transform(({ value }) => sanitizeString(value))
  public customerPoNumber?: string;

  /**
   * Lines to be updated
   */
  @IsNotEmpty()
  public lines: OrderLineUpdateDto[];

  /**
   * Sales order number
   * @example 'SO01B0030048S'
   */
  @IsNotEmpty()
  public orderNumber: string;

  /**
   * Order confirmation ID (aka. ConfirmId in dynamics odata lake)
   * @example 'SOC050000020'
   */
  public orderConfirmationId?: string;

  /**
   * A salesforce contact id is required for notification purposes
   * @example '0015I00000JUmsgQAD'
   */
  public contactId?: string;
}
